<template>
	<page-content-layout class="tracker-list" title="Trackers">
		<button-view slot="tools" label="Opret" @click="createButtonClick" />
		<new-table-view ref="table" :columns="[
			{
				label: 'Label',
				name: 'label'
			},
			{
				label: 'IMEI',
				name: 'imei'
			},
			{
				label: 'Mærke',
				name: 'make'
			},
			{
				label: 'Model',
				name: 'model'
			},
			{
				label: 'Model',
				name: 'model'
			},
			{
				label: 'Køretøj',
				name: 'vehicle_name'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				}
			}
		]" :items="items" @itemClick="itemClick" @delete="itemDelete" />
	</page-content-layout>
</template>

<script>
	import Window from '../windows/TrackerWindow'
	import NewTableView from '../views/NewTableView'

    export default {
		props: [],
		components: { NewTableView },
		methods: {
			createButtonClick: function () {
				var self = this;

				this.$store.state.windowStack.push(Window, {
					onChange: function (ent) {
						
						

						self.update();
					}
				});
			},
			itemClick: function (item) {
				var self = this;

				this.$store.state.windowStack.push(Window, {id: item.id, form: true, onChange: function () {
					self.update();
				}});
			},
			itemDelete: function (item) {
				if (confirm('Sikker?')) {
					

					var self = this;

					this.axios
						.delete('/tracking/trackers/' + item.id + '/')
						.then(function () {
							self.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
			update() {
				var contacts = this;

				this.axios
					.get('/tracking/trackers/')
					.then(function (r) {
						contacts.items = r.data._items;
					});
			}
		},
		data: function () {
			return {
				items: [],
				actions: [
					{name: 'delete', label: 'Delete'}
				]
			};
		},
		mounted: function () {
			this.axios.put('/activity/trackers/');

			this.update();


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		}
    }
</script>

<style lang="scss">

</style>